import { render, staticRenderFns } from "./RenewAffiliateCard.vue?vue&type=template&id=11bcdde3"
import script from "./RenewAffiliateCard.vue?vue&type=script&lang=ts"
export * from "./RenewAffiliateCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports